
import './index.css';

import React from 'react';
import { Link } from 'react-router-dom';
import StatusBadge from '../../ui/StatusBadge';
import RecordSection from '../../view/RecordSection';

const typeKey = 'record-edit-header';

function RecordFormSection({
  id,
  error = null,
  slug,
  header = {},
  data = {},
  children = null,
}) {
  return (
    <div className="stack">

      <form className="stack" onSubmit={header.onSubmit}>

        <header className={['page-header', typeKey, header.className].filter(Boolean).join(' ')}>

          {error ? <p className="error-text">{error}</p> : null}

          <div className={`${typeKey}-bar`}>
            
            {Boolean(data.hasStatus && data.record.data.status) ? (
              <div className="record-status">
                <span className="record-status-toggle">
                  <StatusBadge value={ header.isEditMode ? data.record.data.status : data.initialStatus.value } />
                </span>
              </div>
            ) : null}

            <div className={['action-cluster', `${typeKey}-actions`].filter(Boolean).join(' ')}>
              {header.actions}
              <button className="button-primary" type="submit" disabled={!header.canSubmit || header.saving}>
                {header.saving ? 'Saving...' : 'Save'}
              </button>
              {header.isEditMode && slug && id ? (
                <Link className="button-secondary" to={`/${slug}/${id}`}>
                  Cancel
                </Link>
              ) : ( slug ? (
                <Link className="inline-link" to={`/${slug}`}>
                  Cancel
                </Link>
              ) : null)}
            </div>
          </div>

          {(() => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Data.identity( data.handle.value );
            
            return (
              <div className={`${typeKey}-copy`}>
                <div className={`${typeKey}-title-field`}>
                  <label>
                    {data.handle.label}
                    <Component.Input handle={data.handle.handle} meta={data.handle.meta} record={data.record} context={data.context} onFieldChange={data.onFieldChange} />
                  </label>
                </div>
              </div>
            );
          })()}

        </header>


        <RecordSection title="Details" >
          <div className="record-form-details-grid">
            {data.details.map((detail, index) => {

              const Components = require( '../../../elements' ).default;

              const Component = Components.Data.identity( detail.value );
              
              return (
                <div
                  key={detail.key || index}
                  className={Component.meta.wide ? 'record-form-details-item-wide' : ''}
                >
                  <span className="kv-label">{detail.label}</span>
                  <div>
                    <Component.Input handle={detail.handle} meta={detail.meta} record={data.record} context={data.context} onFieldChange={data.onFieldChange} />
                  </div>
                </div>
              );
            })}
          </div>
        </RecordSection>

        {children}

      </form>
    </div>
  );
}

export default RecordFormSection;
